import { Loader2 } from 'lucide-react';
import { useDashboardData } from '@/hooks/useDashboardData';

import HomeHeader from '@/components/home/HomeHeader';
import InstallShortcutButton from '@/components/home/InstallShortcutButton';
import HomeHeroConsistencyCard from '@/components/home/HomeHeroConsistencyCard';
import DailyFocusCard from '@/components/home/DailyFocusCard';
import PrimaryActionCard from '@/components/home/PrimaryActionCard';
import QuickActionsGrid from '@/components/home/QuickActionsGrid';
import BodySignalsGrid from '@/components/home/BodySignalsGrid';
import DailySummaryCard from '@/components/home/DailySummaryCard';
import ProtocolHighlightCard from '@/components/home/ProtocolHighlightCard';
import WeeklyMiniProgressCard from '@/components/home/WeeklyMiniProgressCard';
import InsightCard from '@/components/home/InsightCard';

const Dashboard = () => {
  const data = useDashboardData();

  if (data.loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="h-8 w-8 text-primary animate-spin" />
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8 max-w-2xl mx-auto space-y-5 animate-fade-in pb-24">
      {/* 1. Smart Header */}
      <HomeHeader userName={data.userName} adaptiveMessage={data.adaptiveMessage} />

      {/* PWA Install Button */}
      <InstallShortcutButton />

      {/* 2. Daily Consistency Hero */}
      <HomeHeroConsistencyCard
        consistency={data.consistency}
        tasksDone={data.tasksDone}
        totalTasks={data.totalTasks}
        streak={data.streak}
        comparisonText={data.comparisonText}
      />

      {/* 3. Daily Focus */}
      <DailyFocusCard focusItems={data.focusItems} />

      {/* 4. Primary Action */}
      <PrimaryActionCard
        checkinDone={data.checkinDone}
        protocolDoneToday={data.protocolDoneToday}
        waterToday={data.waterToday}
      />

      {/* 5. Quick Actions */}
      <QuickActionsGrid
        checkinDone={data.checkinDone}
        protocolDoneToday={data.protocolDoneToday}
        waterToday={data.waterToday}
      />

      {/* 6. Body Signals */}
      <BodySignalsGrid
        hydration={data.hydration}
        bowel={data.bowel}
        energy={data.energy}
        bloating={data.bloating}
      />

      {/* 7. Daily Summary */}
      <DailySummaryCard summary={data.dailySummary} />

      {/* 8. Protocol Highlight */}
      <ProtocolHighlightCard protocol={data.protocol} />

      {/* 9. Weekly Mini Progress */}
      <WeeklyMiniProgressCard weekly={data.weekly} />

      {/* 10. Insight / Recommendation */}
      <InsightCard message={data.insightMessage} />
    </div>
  );
};

export default Dashboard;